import request from '@/api/request.js'


// 查询组织架构树
export function getOrgTree(param) {
  return request({
    url: 'oa/org/tree',
    method: 'get',
    params: param
  })
}

export function getUserSign() {
  return request({
    url: 'oa/org/user/sign',
    method: 'get'
  })
}

// 查询系统角色
export function getRole() {
  return request({
    url: 'oa/org/role',
    method: 'get'
  })
}

// 搜索人员
export function getUserByName(param) {
  return request({
    url: 'oa/org/tree/user/search',
    method: 'get',
    params: param
  })
}

export function getDeptByName(param) {
  return request({
    url: 'oa/org/tree/dept/search',
    method: 'get',
    params: param
  })
}


export function checkStoptart(param) {
  return request({
    url: 'card/finaCheckOutMonth/checkOutJZ',
    method: 'get',
    params: param
  })
}

// 搜索人员
export function getUserDepts(userId) {
  return request({
    url: `oa/org/user/${userId}/dept`,
    method: 'get'
  })
}

// 获取审批代理人
export function getUserAgent() {
  return request({
    url: `oa/org/user/agent`,
    method: 'get'
  })
}

// 获取审批代理人
export function setUserAgent(params) {
  return request({
    url: `oa/org/user/agent`,
    method: 'put',
    data: params
  })
}

// 获取审批代理人
export function cancelUserAgent() {
  return request({
    url: `oa/org/user/agent`,
    method: 'delete'
  })
}

export function getUserPickerValue() {
  return request({
    url: '/oa/org/default/user',
    method: 'get',
  })
}

export function getDeptPickerValue() {
  return request({
    url: '/oa/org/default/dept',
    method: 'get',
  })
}

// 查询角色接口（根据ID查询角色）
export function roleSearch(params) {
  return request({
    url: '/role/'+params.roleId,
    method: 'get'
    // params: params
  })
}

// 查询岗位接口
export function postSearch(params) {
  return request({
    url: '/post/'+params.postId,
    method: 'get'
    // params: params
  })
}

// 查询矩阵路由审批人
export function getRoutingUser(routing, formData) {
  return request({
    url: '/oa/org/routing/user',
    method: 'post',
    data: routing,
    params: {
      formData
    }
  })
}

// 查询签到路由审批人
export function getCheckRoutingUser(check, formData) {
  return request({
    url: '/oa/org/check/routing/user',
    method: 'post',
    data: check,
    params: {
      formData
    }
  })
}
export default {
  getOrgTree, getUserByName, getRole, getUserSign,
  getUserDepts, getUserAgent, setUserAgent, cancelUserAgent, roleSearch, postSearch, getRoutingUser, getCheckRoutingUser
}
